import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import HttpClient from '../../utils/HttpClient';
import { TbCircleMinus } from 'react-icons/tb';
import { FiPlusCircle } from 'react-icons/fi';
import Loader from '../../Loader/Loader';
import { Modal, ModalHeader, ModalBody, Button, Table } from 'reactstrap';
import { FaEdit, FaEye, FaTimes } from 'react-icons/fa';

const Testimonials = () => {
    const testimonialInit = {
        title: "",
        heading: "",
        description: "",
        logo: ""
    }
    const [testiMonialData, setTestiMonialData] = useState([testimonialInit])
    const [loading, setLoading] = useState(false);

    const [testiMonialGetData, setTestiMonialGetData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [sectionID, setSectionId] = useState("")
    const [viewData, setViewData] = useState("")

    const toggleModal = () => setModalOpen(!modalOpen);

    // Handle View Details
    const handleViewDetails = (data) => {
        toggleModal();
        if (data) {
            setViewData(data)
        } else {
            setViewData("")
        }
    }


    // Handle Edit
    const handleEdit = () => {
        setIsEdit(true)
        setTestiMonialData(testiMonialGetData?.map(service => ({
            title: service?.title || '',
            heading: service?.heading || "",
            description: service?.description || "",
            logo: service?.logo || ''
        })));
    };


    // >>>>Handle Incrementing Testimonial Input<<<<
    // const handleAddTestimonial = () => {
    //     setTestiMonialData(prev => [...prev, { ...testimonialInit }]);
    // };

    const handleAddTestimonial = () => {
        setTestiMonialData(prev => [{ ...testimonialInit }, ...prev]);
    };

    // >>>>Handle Decrementing Testimonial Input<<<<
    const handleRemoveTestiminal = (index) => {
        setTestiMonialData(prev => prev.filter((_, i) => i !== index));
    };

    // >>>>Handle Testimonial Input Change<<<<
    const handleTestimonialChange = (index, field, value) => {
        setTestiMonialData(prev => {
            const updatedTestimonial = [...prev];
            updatedTestimonial[index] = { ...updatedTestimonial[index], [field]: value };
            return updatedTestimonial;
        });
    };

    // >>>>Handle Image Upload<<<<
    const handleImageChange = async (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            toast.error("Image size must be less than 5 MB");
            return;
        }

        let formData = new FormData();
        formData.append("image", file);
        setLoading(true)
        const res = await HttpClient.fileUplode("image-upload", "POST", formData);
        if (res && res.status) {
            setLoading(false)
            toast.success("Image Uploaded Successfully");
            handleTestimonialChange(index, 'logo', res?.url);
        } else {
            setLoading(false)
            toast.error(res?.message || "Something went wrong");
        }
    };

    // >>>>Handle Removing Image<<<<
    const handleRemoveImage = (index) => {
        handleTestimonialChange(index, 'logo', "");
        document.getElementById(`image-${index}`).value = "";
    };

    // Fetch Testimonial Data
    const fetchTestimonialData = async () => {
        setLoading(true);
        const res = await HttpClient.requestData("home", "GET");
        if (res && res?.status) {
            setLoading(false);
            setSectionId(res?.data?._id)
            setTestiMonialGetData(res.data ? res?.data?.testimonial : []);
        } else {
            setLoading(false);
            setTestiMonialGetData([]);
        }
    }


    // >>>>Handle Submit Data<<<<
    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            testimonial: testiMonialData,
        }
        console.log("carrerData", data)

        // return
        setLoading(true)
        const res = await HttpClient.requestData(`home/${sectionID}`, "PUT", data);
        if (res && res?.status) {
            setLoading(false)
            toast.success(res?.message || "Data updated successfully.!");
            setTestiMonialData([testimonialInit])
            setIsEdit(false)
            fetchTestimonialData()
            document.querySelectorAll('input[type="file"]').forEach(input => input.value = '');
        } else {
            setLoading(false)
            return toast.error(res?.message || "Something went wrong...!")
        }
    }

    useEffect(() => {
        fetchTestimonialData()
    }, [])
    return (
        <div className="d-flex justify-content-end">
            {loading && <Loader />}
            <div className="form-header mx-2">
                <section className="piechartsBox_area">
                    {/* Testimonial  */}
                    {isEdit &&
                        <>
                            <form onSubmit={handleSubmit}>
                                <div className='p-2 mb-4' style={{ border: "1px solid #eee" }}>
                                    <div className='d-flex'>
                                        <h2 >Testimonial</h2> <span className='mt-2 mx-2' style={{ cursor: "pointer", color: "green" }} onClick={handleAddTestimonial}><FiPlusCircle /> Add More Testimonials</span>
                                    </div>
                                    <div style={{ height: "450px", overflow: "auto" }}>
                                        {testiMonialData?.map((ele, index) => (
                                            <div className="form-group section p-2 mt-2" style={{ border: "1px solid #ccc" }}>
                                                <div className="form-group mb-3">
                                                    {index !== -1 && (
                                                        <span

                                                            onClick={() => handleRemoveTestiminal(index)}
                                                        >
                                                            <TbCircleMinus style={{ cursor: "pointer", color: "red", marginTop: "-3px", marginRight: "2px" }} />
                                                        </span>
                                                    )}
                                                    <label htmlFor="heading2">Title</label>
                                                    <input type="text" id="heading2" name="title" className="form-control" value={ele?.title} onChange={(e) => handleTestimonialChange(index, 'title', e.target.value)} />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label htmlFor="heading2">Heading</label>
                                                    <input type="text" id="heading2" name="heading" className="form-control" value={ele?.heading} onChange={(e) => handleTestimonialChange(index, 'heading', e.target.value)} />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label htmlFor="description2">Description</label>
                                                    <textarea id="description2" name="description" className="form-control" rows="3" value={ele?.description} onChange={(e) => handleTestimonialChange(index, 'description', e.target.value)}></textarea>
                                                </div>

                                                <div className='d-flex'>
                                                    <div className="form-group mb-6 w-50">
                                                        <label htmlFor={`image-${index}`}>Logo</label>
                                                        <input
                                                            type="file"
                                                            id={`image-${index}`}
                                                            name="image"
                                                            className="form-control"
                                                            accept="image/*"
                                                            onChange={(e) => handleImageChange(index, e)}
                                                        />
                                                    </div>
                                                    {ele?.logo && (
                                                        <div className="mx-5 d-flex align-items-center justify-content-center">
                                                            <img
                                                                className=""
                                                                alt="service"
                                                                width={"100px"}
                                                                height={"100px"}
                                                                src={ele?.logo}
                                                                style={{ border: "1px solid #000", borderRadius: "10px", boxShadow: "0 7px 8px rgba(0,0,0,0.5)" }}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginTop: "-4em", fontSize: "20px", cursor: "pointer"
                                                                }}
                                                                onClick={() => handleRemoveImage(index)}
                                                            >
                                                                <i className="fa-solid fa-square-xmark" style={{ color: "#b40822" }}></i>
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                        }
                                    </div>
                                </div>

                                <div className='d-flex justify-content-center mt-2'>
                                    <button type='submit' className='btn btn-outline-success w-75'>Update</button>
                                </div>
                            </form>
                            <hr />
                        </>
                    }

                    {testiMonialGetData && !isEdit && (
                        <div className="mt-5">
                            <h3>Testimonial Data</h3>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Hading</th>
                                        <th>Description</th>
                                        <th>Logo</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {testiMonialGetData?.length !== 0 ? (
                                        testiMonialGetData?.map((service, index) => (
                                            <tr key={service._id}>
                                                <td>{service?.title || '-'}</td>
                                                <td>{service?.heading || '-'}</td>
                                                <td>{service?.description || '-'}</td>
                                                <td>
                                                    {service.logo ? (
                                                        <img
                                                            alt="Service"
                                                            width={"100px"}
                                                            height={"100px"}
                                                            src={service.logo}
                                                            style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                        />
                                                    ) : (
                                                        '-'
                                                    )}
                                                </td>
                                                <td>
                                                    <FaEye
                                                        style={{ cursor: "pointer", marginRight: "15px", color: "#007bff" }}
                                                        onClick={() => handleViewDetails(service)}
                                                        title="View Details"
                                                    />
                                                    <FaEdit
                                                        style={{ cursor: "pointer", color: "#28a745" }}
                                                        onClick={handleEdit}
                                                        title="Edit"
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center">No services available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* Modal for Viewing Details */}
                    <Modal isOpen={modalOpen} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>Testimonial Details
                            <span style={{ marginLeft: "455px", cursor: "pointer" }} onClick={toggleModal}>
                                <FaTimes className='' style={{ marginTop: "-80px" }} />
                            </span>
                        </ModalHeader>
                        <ModalBody>
                            <div style={{ overflow: "auto", height: "300px" }}>
                                <Table className="table">
                                    <thead>
                                        <tr>
                                            <th>Field</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Title</td>
                                            <td>{viewData?.title || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>Heading</td>
                                            <td>{viewData?.heading || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>Description</td>
                                            <td>{viewData?.description || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>Logo</td>
                                            <td>
                                                {viewData.logo ? (
                                                    <img
                                                        alt="Service"
                                                        width={"100px"}
                                                        height={"100px"}
                                                        src={viewData.logo}
                                                        style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                    />
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </ModalBody>
                        <Button color="secondary" onClick={toggleModal}>Close</Button>
                    </Modal>
                </section>
            </div>
        </div >
    )
}

export default Testimonials